import React from "react";
import { FaTools, FaDollarSign, FaLink, FaRocket, FaBrain, FaShieldAlt } from "react-icons/fa";
import "./WhatYouGain.css";

const WhatYouGain = () => {
  const benefits = [
    {
      icon: FaTools,
      title: "A System Built For them, Not Adapted",
      description:
        "Designed around their workflows and industry. No forced processes, no compromises. Every module works exactly how their business operates.",
    },
    {
      icon: FaDollarSign,
      title: "Freedom From SaaS & Licensing Traps",
      description:
        "No monthly per-user fees. No surprise price increases. One-time build → decades of benefit.",
    },
    {
      icon: FaLink,
      title: "One Technology Partner — Everything Connected",
      description:
        "Sales, Inventory, Finance, AI, Reports, Logistics. No disconnected tools or data silos. One unified source of truth.",
    },
    {
      icon: FaRocket,
      title: "Future-Proof for 15–25 Years",
      description:
        "Modular, extensible architecture. Easy upgrades without rebuilding. Grows as their business grows.",
    },
    {
      icon: FaBrain,
      title: "Practical AI With Real ROI",
      description:
        "AI trained on their operational data. Smarter forecasts, routes, pricing, and decisions. Competitive advantage that compounds over time.",
    },
    {
      icon: FaShieldAlt,
      title: "Full Ownership, Security & Control",
      description:
        "Their data stays theirs. On-premise or private cloud options. Compliance tailored to their region & industry.",
    },
  ];

  const reasons = [
    "Lower long-term cost than SaaS",
    "Faster operations with fewer errors",
    "Stronger margins through intelligence",
    "Software that never becomes obsolete",
    "A technology partner invested in your growth",
  ];

  return (
    <section className="what-you-gain-section">
      <div className="gain-container">
        {/* Main Title */}
        <div className="gain-header">
          <h2 className="gain-main-title">What Clients Gain With Instant Digits</h2>
        </div>

        {/* Benefits Grid */}
        <div className="benefits-grid-main">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div key={index} className="benefit-item-simple">
                <div className="benefit-icon-simple">
                  <IconComponent />
                </div>
                <div className="benefit-content-simple">
                  <h3 className="benefit-title-simple">{benefit.title}</h3>
                  <p className="benefit-description-simple">{benefit.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Why Businesses Choose */}
        <div className="why-choose-section">
          <div className="reasons-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="reason-item">
                <span className="reason-checkmark">✔</span>
                <p className="reason-text">{reason}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Philosophy Section */}
        <div className="philosophy-section">
          <h3 className="philosophy-title">Our Philosophy</h3>
          <div className="philosophy-content">
            <p className="philosophy-text">
              Most companies rent software forever.
              <br />
              <span className="philosophy-highlight">
                Instant Digits helps them own their digital future.
              </span>
            </p>
            <p className="philosophy-text">
              We don't disappear after delivery.
              <br />
              <span className="philosophy-highlight">
                Simply, We evolve your system as your business evolves.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouGain;
